



































































































































































import settings from '../settings.coffee'
import gql from '@/gqlService.coffee'
import queries from "@/gql/queries.coffee"
export default {
  "name": 'login'
  "data": ()->
      loading: true
      error: ""
      username: ""
      password: ""
      logoUrl: ""
      label: ""
      mainText: ""
      siteLinkText: ""
      phone: ""
      email: "",
      placholderLogin: "Login"
  "methods":
      "get_schema": ()->
          response = await gql.getSchema()
          if response.ok
              @$store.dispatch("set_schema", response.body.data.__schema)
          response = await queries.run("get_tag_name")
          this.$store.commit(
              'set_tag_name',
              JSON.parse(response.body.data.tag_name))
          response = await queries.run('get_consultants_stats_from_view', [])
          this.$store.commit(
              'set_stats',
              response.body.data.get_consultants_stats_from_view)
      "login": ()->
          self = @
          self.error = ""
          this.$http.post(settings.authApiUrl, JSON.stringify({
              username: this.$data.username
              password: this.$data.password
          })).then (subdata)->
              console.log(subdata)
              if subdata.body.status == "loggedin"
                  this.$store.dispatch('set_authenticated', subdata.body.profile)
                  if this.$route.params.next
                      to = this.$route.params.next
                      this.$router.push({ path: to })
                  else
                      this.$router.push({ path: '/' })
                  self.get_schema()
              else
                  this.$data.error =  subdata.body.status
      "getSetting": ()->
          self = @ 
          self.error = ""
          this.$http.get(settings.backendUrl+"/admin/setting/")
          .then (data)->
              for s in data.body.settings
                  if s.slug == 'instance_logo'
                      @logoUrl = settings.backendMediaUrl + s.file
                  if s.slug == 'instance_name'
                      @label = s.value
                  if s.slug == 'instance_main_text'
                      @mainText = s.value
                  if s.slug == 'instance_site_link'
                      @siteLinkText = s.value
                  if s.slug == 'instance_phone'
                      @phone = s.value
                  if s.slug == "instance_email"
                      @email = s.value
  "mounted": ()->
      self = @
      setTimeout(()->
          new AcornIcons().replace()
          return
      ,200)
      @getSetting()
      this.$http.get(settings.authApiUrl).then (data)->
          this.$cookie.set('csrftoken', data.body.csrf)
          this.$http.post(settings.authApiUrl).then (subdata)->
              if subdata.body.status == "loggedin"
                  to = this.$route.params.next
                  this.$store.dispatch('set_authenticated', subdata.body.profile)
                  # this.$store.dispatch("authenticated")
                  if to
                      this.$router.push({ path: to })
                  else
                      this.$router.push({ path: '/' })
                  self.get_schema()
              else
                  this.$data.loading = false
                  this.$store.dispatch('set_authenticated', null)

}
